<script lang="ts">
    import { Followup } from "../../../utils/Constant/Constant";
    import CommonContent from "./CommonContent.svelte";
</script>
<CommonContent header={Followup} getId={"Followup-tab"} />
